import { createFileRoute } from "@tanstack/react-router";

import { InvestorInvitationsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/investor-invites")({
  component: InvestorInvitationsPage,
});
